<template>
<div class="wc__session-stopped">
  {{ $t('web-conferences.sessionStopped') }}
</div>
</template>

<script>
export default {
  name: "StoppedScreen"
}
</script>

<style scoped lang="scss">
@import "../styles/session-stopped";
</style>